import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirstLetter'
})
export class CapitalizeFirstLetterPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Split the string into an array of words
    const words = value.split(' ');

    // Capitalize the first letter of each word
    const capitalizedWords = words.map(word => {
      const firstLetter = word.charAt(0).toUpperCase();
      const restOfWord = word.slice(1).toLowerCase();
      return firstLetter + restOfWord;
    });

    // Join the words back together with spaces
    const capitalizedText = capitalizedWords.join(' ');

    return capitalizedText;
  }
}